import { FileTypeName } from 'api/types/entity';
import { mixed, number, object, string } from 'yup';

import { date } from './date';

export const localFileSchema = object({
  id: string(),
  name: string().required(),
  size: number().required(),
  createdAt: date().required(),
  type: mixed<FileTypeName>().oneOf(Object.values(FileTypeName)).required(),
});
